var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-layout',[_c('template',{slot:"content"},[_c('app-login')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }